module.exports = __webpack_public_path__ + "static/media/pressure_gauge.8501a2de.png";